<template>
  <div class="card card-custom gutter-b invigilation-report-page">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title">
        <h3 class="card-label">Báo cáo coi thi</h3>
      </div>
    </div>

    <div class="card-body">
      <ReportFilters v-model="filters" :options="filterOptions" @change="handleFilterChange" />

      <ReportSkeleton v-if="loading" />
      <div v-else-if="report" class="report-grid">
        <ViolationMetricCard :report="report.cheating" />
        <ViolationMetricCard :report="report.regulation" />
        <StaffRanking :ranking="report.ranking" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import {SET_BREADCRUMB} from '@/core/services/store/breadcrumbs.module';
import {
  GET_INVIGILATION_REPORT
} from '@/core/services/store/marking/invigilationReport.module';
import {GET_CENTER_BRAND_E} from '@/core/services/store/center/centers.module';
import {GET_LIST_BRANCHES} from '@/core/services/store/center/branch.module';
import {GET_LIST_AREAS} from '@/core/services/store/center/area.module';
import ReportFilters from './components/ReportFilters.vue';
import ReportSkeleton from './components/ReportSkeleton.vue';
import StaffRanking from './components/StaffRanking.vue';
import ViolationMetricCard from './components/ViolationMetricCard.vue';

const EXAM_TYPES = [
  {id: 1, name: 'Thi thử'},
  {id: 0, name: 'Thi cuối khóa'},
  {id: 3, name: 'Thi lại'}
];
const EXAM_FORMS = [
  {id: 1, name: 'ONLINE'},
  {id: 2, name: 'OFFLINE'}
];
const DEPARTMENTS = [
  {id: 30, name: 'Bộ phận Admin'},
  {id: 46, name: 'Bộ phận QC'}
];

export default {
  name: 'InvigilationReport',
  components: {
    ReportFilters,
    ReportSkeleton,
    StaffRanking,
    ViolationMetricCard
  },
  data() {
    return {
      loading: true,
      filters: {
        center_id: null,
        branch_ids: [],
        area_ids: [],
        exam_type_ids: [],
        exam_form: null,
        exam_date: [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')],
        department_id: null
      },
      filterOptions: {
        centers: [],
        branches: [],
        areas: [],
        exam_types: [],
        exam_forms: [],
        departments: []
      },
      report: null
    };
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: 'Coi thi - Chấm thi'},
      {title: 'Báo cáo chỉ số coi thi'}
    ]);
    await this.loadFilterOptions();
    await this.loadReport();
  },
  methods: {
    async loadFilterOptions() {
      try {
        const [centers, branches, areas] = await Promise.all([
          this.$store.dispatch(GET_CENTER_BRAND_E),
          this.$store.dispatch(GET_LIST_BRANCHES, {}),
          this.$store.dispatch(GET_LIST_AREAS, {})
        ]);
        this.filterOptions = {
          centers: centers?.data || [],
          branches: branches?.data || [],
          areas: areas?.data || [],
          exam_types: EXAM_TYPES,
          exam_forms: EXAM_FORMS,
          departments: DEPARTMENTS
        };
      } catch (error) {
        this.$message.error(error?.data?.message || error.message || 'Không tải được bộ lọc báo cáo.');
      }
    },
    async loadReport() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch(GET_INVIGILATION_REPORT, this.reportParams());
        if (response.error) throw new Error(response.message || 'Không tải được báo cáo coi thi.');
        this.report = this.normalizeReport(response.data || {});
      } catch (error) {
        this.$message.error(error?.data?.message || error.message || 'Không tải được báo cáo coi thi.');
      } finally {
        this.loading = false;
      }
    },
    reportParams() {
      const params = {
        center_id: this.filters.center_id,
        branch_ids: this.filters.branch_ids,
        area_ids: this.filters.area_ids,
        exam_type: this.filters.exam_type_ids,
        exam_form: this.filters.exam_form,
        date_range: this.filters.exam_date,
        department_id: this.filters.department_id
      };
      return Object.keys(params).reduce((result, key) => {
        const value = params[key];
        if (value !== null && value !== undefined && value !== '' && (!Array.isArray(value) || value.length)) {
          result[key] = value;
        }
        return result;
      }, {});
    },
    normalizeReport(data) {
      return {
        cheating: this.normalizeTypeReport(data.gian_lan, 'GIAN LẬN'),
        regulation: this.normalizeTypeReport(data.vi_pham_quy_che, 'VI PHẠM QUY CHẾ'),
        ranking: (data.top_staff || []).map((staff, index) => ({
          id: staff.user_id || `staff-${index}`,
          name: staff.name || 'Không xác định',
          summary: '',
          score: staff.count || 0
        }))
      };
    },
    normalizeTypeReport(section = {}, title) {
      return {
        title,
        total: section.total || 0,
        online: this.normalizeFormStats(section.online),
        offline: this.normalizeFormStats(section.offline),
        activities: (section.activity_log || []).map(activity => ({
          exam_form: activity.exam_form_label || '',
          name: activity.reason || 'Không có',
          count: activity.count || 0
        }))
      };
    },
    normalizeFormStats(stats = {}) {
      const rate = Number(stats.percent || 0);
      return {
        rate,
        total: stats.total || 0,
        admin: stats.admin || 0,
        other: stats.other || 0,
        passed: stats.passed ?? rate <= 10
      };
    },
    async handleFilterChange(field) {
      if (field === 'center_id') {
        this.filters.branch_ids = [];
        try {
          const response = await this.$store.dispatch(GET_LIST_BRANCHES, {
            center_id: this.filters.center_id
          });
          this.filterOptions.branches = response?.data || [];
        } catch (error) {
          this.filterOptions.branches = [];
          this.$message.error(error?.data?.message || error.message || 'Không tải được danh sách chi nhánh.');
        }
      }
      await this.loadReport();
    }
  }
};
</script>

<style scoped lang="scss" src="./InvigilationReport.scss"></style>
